import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import React, { useState } from "react";
import { View, Text, StyleSheet } from "react-native";
import { useTheme } from "styled-components/native";
import ReactDOM from "react-dom";
import { TooltipTextProps } from "./types";
import { productLevelOneColor } from "@utils/product/productTheme";
import { ProductCategory } from "@utils/constants";

const TooltipImage = ({
  tooltip,
  enableTooltip,
  productType,
}: TooltipTextProps) => {
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const handleMouseEnter = (event) => {
    const { clientX } = event;
    const rect = event.target.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + window.scrollY + 10,
      left: clientX,
    });
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <View
      style={styles.container}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* Replace this with actual image/icon component if needed */}
      <VDBIcon
        color={theme[productLevelOneColor(productType as ProductCategory)]}
        size={SpaceType.LargeDouble}
        variant={IconsVariant.VDBCustom}
        name={VDBIcons.PRICE_COMMENT}
      />

      {isHovered &&
        enableTooltip &&
        ReactDOM.createPortal(
          <View
            style={[
              styles.tooltipContainer,
              {
                position: "absolute",
                top: tooltipPosition.top,
                left: tooltipPosition.left,
                transform: [{ translateX: -10 }], // Center horizontally
              },
            ]}
          >
            <View style={styles.arrow} />
            <View style={styles.tooltip}>
              <Text style={styles.tooltipText}>{tooltip}</Text>
            </View>
          </View>,
          document.body
        )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    cursor: "pointer",
  },
  tooltip: {
    position: "absolute",
    backgroundColor: "black",
    padding: 8,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 4,
    zIndex: 10,
    width: 100,
    maxWidth: 200,
    flexWrap: "wrap",
    display: "flex",
    flexDirection: "row",
  },
  tooltipContainer: {
    alignItems: "center",
    zIndex: 1000,
  },
  tooltipText: {
    fontSize: 12,
    color: "#fff",
  },
  arrow: {
    width: 0,
    height: 0,
    top: -5,
    borderLeftWidth: 6,
    borderRightWidth: 6,
    borderBottomWidth: 6,
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderBottomColor: "black",
    marginBottom: -1,
  },
});

export default TooltipImage;
